module.exports = __webpack_public_path__ + "img/@logo_abl@3x.4e314221.png";